const key = 'PROMINHO_CURRENT_SELLER_ID'

export const setCurrentSellerSelected = (sellerId: any) =>
  localStorage.setItem(key, sellerId)

export const getCurrentSellerSelected = () => localStorage.getItem(key)
